import React from 'react';
import PropTypes from 'prop-types';
import style from "../../../styles/styles";
import {Paper, List, Subheader, Toggle} from 'material-ui';
import Loading from "../../common/Loading/Loading";
import withTranslation from "../../../hoc/withTranslation";
import ModuleService from "../../../services/module";
import styles from './ReportSetting.css';

class ReportSetting extends React.Component {
    static propTypes = {
        app: PropTypes.object,
        editConfiguration: PropTypes.func
    };

    static defaultProps = {
        app: null,
        loading: false
    };

    handleToggledUserView = (event, isInputChecked) => {
        this.props.editConfiguration('user_can_only_see_their_reports', isInputChecked);
    };
    handleToggledSendAdminReportMail = (event, isInputChecked) => {
        this.props.editConfiguration('send_new_report_admin_mail', isInputChecked);
    };
    handleToggledSendReportPush = (event, isInputChecked) => {
        this.props.editConfiguration('send_report_push', isInputChecked);
    };

    render() {
        const {loading, app} = this.props;
        let content;
        if (loading) {
            content = <Loading paper={false} />;
        } else {
            content = <div>
                <Toggle
                    style={styles.toggle}
                    label={this.props.t('settings_page.report_user_can_only_see_their_reports_settings')}
                    toggled={app.configurations.user_can_only_see_their_reports}
                    labelPosition="right"
                    onToggle={this.handleToggledUserView}
                />
                <Toggle
                    style={styles.toggle}
                    label={this.props.t('settings_page.send_new_report_admin_mail_settings')}
                    toggled={app.configurations.send_new_report_admin_mail}
                    labelPosition="right"
                    onToggle={this.handleToggledSendAdminReportMail}
                />
                {ModuleService.hasModule(app, ModuleService.PUSH)
                    && ModuleService.isPushModuleConfigured(app)
                    && (
                        <Toggle
                            style={styles.toggle}
                            label={this.props.t('settings_page.send_report_push_settings')}
                            toggled={app.configurations.send_report_push}
                            labelPosition="right"
                            onToggle={this.handleToggledSendReportPush}
                        />
                    )}
            </div>
        }

        return <Paper>
            <List>
                <Subheader style={{...style.subHeader, ...style.relative}}>
                    {this.props.t('module.report.name')}
                </Subheader>

                <div style={style.paper}>
                    {content}
                </div>
            </List>
        </Paper>
    }
}

export default withTranslation(ReportSetting);



// WEBPACK FOOTER //
// src/components/common/ReportSetting/ReportSetting.js